function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.75 17.5H30M23.75 22.5H30M14.39 22.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM9.548 26.25a5.002 5.002 0 019.685 0",
  stroke: "#1B8388",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.75 7.5H6.25C5.56 7.5 5 8.06 5 8.75v22.5c0 .69.56 1.25 1.25 1.25h27.5c.69 0 1.25-.56 1.25-1.25V8.75c0-.69-.56-1.25-1.25-1.25z",
  stroke: "#1B8388",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIdentificationCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIdentificationCard;